import _ from 'lodash'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'

const verificaOfferteCarrello = (context) => {
  let righeModificate = []
  for (const r of context.righeCarrello) {
    const righe = verificaOffertaRigaCarrello(context, r)
    righeModificate = righeModificate.concat(righe)
  }
  return _.uniqBy(righeModificate, 'codoceRiga')
}

const verificaOffertaRigaCarrello = (context, riga) => {
  if (!context.offerte || context.offerte.length === 0) {
    return
  }
  const quantita = riga.quantita
  const quantitaSomma = _.sumBy(context.righeCarrello.filter(x => x.codice === riga.codice), 'quantita')
  const offerteAttive = []
  for (const o of context.offerte.filter(x => x.attiva)) {
    if (o.soloFidelity && !context.fidelityCard) {
      continue
    }
    const orarioValido = testOrarioValido(o)
    if (orarioValido) {
      offerteAttive.push(o)
    }
  }
  let prezzoOfferta = parseFloat(riga.prezzoUnitario)
  let descrizioneOfferta = ''
  // let rigaSconto = null
  for (const o of offerteAttive) {
    if (quantitaSomma < (o.quantitaMinima || 1)) {
      continue
    }
    switch (o.tipoOfferta) {
      case 'categoria':
        var campoVerifica = o.campoVerifica.codice || o.campoVerifica
        var valore = _.get(riga, campoVerifica, '')
        if (o.valori.includes(valore)) {
          let prezzo = parseFloat(riga.prezzoUnitario)
          prezzo = prezzo * (1 - (o.scontoPercentuale || 0) / 100)
          prezzo = prezzo - (o.scontoEuro || 0)
          prezzoOfferta = +prezzo.toFixed(2)
          descrizioneOfferta = o.descrizioneScontrino || o.descrizione
          break
        }
        break
      case 'prodotto':
        var trovato = o.articoli.find(x => x.id === riga.codice || x.codice === riga.codice)
        if (trovato) {
          let prezzo = parseFloat(riga.prezzoUnitario)
          if (trovato.prezzo || trovato.scontoPercentuale || trovato.scontoEuro) {
            if (trovato.prezzo) {
              prezzo = trovato.prezzo
            } else {
              prezzo = prezzo * (1 - (trovato.scontoPercentuale || 0) / 100)
              prezzo = prezzo - (trovato.scontoEuro || 0)
            }
          } else {
            prezzo = prezzo * (1 - (o.scontoPercentuale || 0) / 100)
            prezzo = prezzo - (o.scontoEuro || 0)
          }
          prezzoOfferta = +prezzo.toFixed(2)
          descrizioneOfferta = o.descrizioneScontrino || o.descrizione
          break
        }
        break
      default:
        break
    }
  }
  /*   if (prezzoOfferta !== riga.prezzo) {
    const sconto = (riga.prezzo - prezzoOfferta) * quantita
    const iva = riga.iva || {}
    var subriga = {
      quantita: 0,
      descrizione: `${descrizioneOfferta}`,
      prezzoUnitario: 0,
      prezzo: (-sconto).toFixed(2),
      tipo: 'abbuono',
      aliquota: iva.aliquota,
      natura: iva.natura,
      valore: sconto.toFixed(2),
      rigaCodice: uuidv4(),
      origine: 'offerta'
    }
    rigaSconto = subriga
  } */
  if (prezzoOfferta !== riga.prezzo && quantitaSomma !== quantita) {
    // Ho applicato un'offerta e nello scontrino il prodotto è presente in altre righe --> deve applicare lo sconto a tutte le righe
    for (const r of context.righeCarrello.filter(x => x.codice === riga.codice)) {
      const qtaRiga = r.quantita
      const sconto = (parseFloat(r.prezzoUnitario) - prezzoOfferta) * qtaRiga
      const iva = r.iva || {}
      const subriga = {
        quantita: 0,
        descrizione: `${descrizioneOfferta}`,
        prezzoUnitario: 0,
        prezzo: (-sconto).toFixed(2),
        tipo: 'abbuono',
        aliquota: iva.valore,
        natura: iva.natura,
        valore: sconto.toFixed(2),
        rigaCodice: uuidv4(),
        origine: 'offerta'
      }
      r.sconto = subriga
    }
  }

  if (prezzoOfferta === riga.prezzo && quantitaSomma !== quantita) {
    const righeModificate = []
    for (let i = 0; i < context.righeCarrello.length; i++) {
      if (context.righeCarrello[i].codice === riga.codice && context.righeCarrello[i].sconto && context.righeCarrello[i].sconto.origine === 'offerta') {
        righeModificate.push(i)
        delete context.righeCarrello[i].sconto
      }
    }
    return righeModificate
  }
}

const testOrarioValido = (offerta) => {
  let orarioValido = false
  if (moment().isBetween(offerta.dataDa || moment().add(-1, 'd'), offerta.dataA || moment().add(1, 'd'))) {
    orarioValido = true
    // TODO: Completare
    if (offerta.orari && offerta.orari.length > 0) {
      let orarioTrovato = false
      for (const r of offerta.orari) {
        if (r.oraDa && r.oraA) {
          const oreDa = parseInt(r.oraDa.split(':')[0])
          const minutiDa = parseInt(r.oraDa.split(':')[1])
          const oreA = parseInt(r.oraA.split(':')[0])
          const minutiA = parseInt(r.oraA.split(':')[1])
          const istanteDa = moment().local().startOf('day').add(oreDa, 'h').add(minutiDa, 'm')
          const istanteA = moment().local().startOf('day').add(oreA, 'h').add(minutiA, 'm')
          if (moment().local().isBetween(istanteDa, istanteA)) {
            orarioTrovato = true
          }
        }
      }
      orarioValido = orarioTrovato
    }
  }
  return orarioValido
}

// La procedura può essere chiamata sia per inserire una offerta sia per verificare che sia ancora valida togliendo un prodotto dallo scontrino
// (Caso quantità Minima)
const verificaOfferta = (context, quantita, prodottoCancellato) => {
  // TODO: Verificare se accettiamo che un prodotto possa essere su più offerte o consideriamo buona la prima
  // Per adesso buona la prima !
  if (!context.offerte || context.offerte.length === 0) {
    return
  }

  const prodottoVerifica = prodottoCancellato || context.prodotto
  let quantitaSomma = _.sumBy(context.righeCarrello.filter(x => x.codice === prodottoVerifica.ricercaTC.toLowerCase()), 'quantita')
  quantitaSomma = quantitaSomma + quantita
  const offerteAttive = [] // Eventualmente calcolare all'inizio di uno scontrino!
  for (const o of context.offerte.filter(x => x.attiva)) {
    if (o.soloFidelity && !context.fidelityCard) {
      continue
    }
    // TODO: Inserire eventuali controlli su TipoClienteFidelity (es categorie) o direttamente sui clienti ...
    if (moment().isBetween(o.dataDa || moment().add(-1, 'd'), o.dataA || moment().add(1, 'd'))) {
      let orarioValido = true
      // TODO: Completare
      if (o.orari && o.orari.length > 0) {
        let orarioTrovato = false
        for (const r of o.orari) {
          if (r.oraDa && r.oraA) {
            const oreDa = parseInt(r.oraDa.split(':')[0])
            const minutiDa = parseInt(r.oraDa.split(':')[1])
            const oreA = parseInt(r.oraA.split(':')[0])
            const minutiA = parseInt(r.oraA.split(':')[1])
            const istanteDa = moment().local().startOf('day').add(oreDa, 'h').add(minutiDa, 'm')
            const istanteA = moment().local().startOf('day').add(oreA, 'h').add(minutiA, 'm')
            if (moment().local().isBetween(istanteDa, istanteA)) {
              orarioTrovato = true
            }
          }
        }
        orarioValido = orarioTrovato
      }
      if (orarioValido) {
        offerteAttive.push(o)
      }
    }
  }
  let prezzoOfferta = prodottoVerifica.prezzo
  let descrizioneOfferta = ''
  let rigaSconto = null
  for (const o of offerteAttive) {
    if (quantitaSomma < (o.quantitaMinima || 1)) {
      continue
    }
    switch (o.tipoOfferta) {
      case 'categoria':
        var campoVerifica = o.campoVerifica.codice || o.campoVerifica
        var valore = _.get(prodottoVerifica, campoVerifica, '')
        if (o.valori.includes(valore)) {
          let prezzo = prodottoVerifica.prezzo
          prezzo = prezzo * (1 - (o.scontoPercentuale || 0) / 100)
          prezzo = prezzo - (o.scontoEuro || 0)
          prezzoOfferta = +prezzo.toFixed(2)
          descrizioneOfferta = o.descrizioneScontrino || o.descrizione
          break
        }
        break
      case 'prodotto':
        var trovato = o.articoli.find(x => x.id === prodottoVerifica.ricercaTC || x.codice === prodottoVerifica.codice)
        if (trovato) {
          let prezzo = prodottoVerifica.prezzo
          if (trovato.prezzo || trovato.scontoPercentuale || trovato.scontoEuro) {
            if (trovato.prezzo) {
              prezzo = trovato.prezzo
            } else {
              prezzo = prezzo * (1 - (trovato.scontoPercentuale || 0) / 100)
              prezzo = prezzo - (trovato.scontoEuro || 0)
            }
          } else {
            prezzo = prezzo * (1 - (o.scontoPercentuale || 0) / 100)
            prezzo = prezzo - (o.scontoEuro || 0)
          }
          prezzoOfferta = +prezzo.toFixed(2)
          descrizioneOfferta = o.descrizioneScontrino || o.descrizione
          break
        }
        break
      default:
        break
    }
  }

  if (prezzoOfferta !== prodottoVerifica.prezzo) {
    const sconto = (prodottoVerifica.prezzo - prezzoOfferta) * quantita
    const iva = prodottoVerifica.iva || {}
    var subriga = {
      quantita: 0,
      descrizione: `${descrizioneOfferta}`,
      prezzoUnitario: 0,
      prezzo: (-sconto).toFixed(2),
      tipo: 'abbuono',
      aliquota: iva.valore,
      natura: iva.natura,
      valore: sconto.toFixed(2),
      rigaCodice: uuidv4(),
      origine: 'offerta'
    }
    rigaSconto = subriga
  }

  if (prezzoOfferta !== prodottoVerifica.prezzo && quantitaSomma !== quantita) {
    // Ho applicato un'offerta e nello scontrino il prodotto è presente in altre righe --> deve applicare lo sconto a tutte le righe
    for (const r of context.righeCarrello.filter(x => x.codice === prodottoVerifica.ricercaTC.toLowerCase())) {
      const qtaRiga = r.quantita
      const sconto = (parseFloat(r.prezzoUnitario) - prezzoOfferta) * qtaRiga
      const iva = r.iva || {}
      subriga = {
        quantita: 0,
        descrizione: `${descrizioneOfferta}`,
        prezzoUnitario: 0,
        prezzo: (-sconto).toFixed(2),
        tipo: 'abbuono',
        aliquota: iva.valore,
        natura: iva.natura,
        valore: sconto.toFixed(2),
        rigaCodice: uuidv4(),
        origine: 'offerta'
      }
      r.sconto = subriga
    }
  }

  if (prodottoCancellato && prezzoOfferta === prodottoVerifica.prezzo && quantita === 0) {
    const righeModificate = []
    for (let i = 0; i < context.righeCarrello.length; i++) {
      if (context.righeCarrello[i].codice === prodottoVerifica.ricercaTC.toLowerCase() && context.righeCarrello[i].sconto && context.righeCarrello[i].sconto.origine === 'offerta') {
        righeModificate.push(i)
        delete context.righeCarrello[i].sconto
      }
    }
    return righeModificate
  }
  return prodottoCancellato ? [] : rigaSconto
}

export default {
  verificaOfferteCarrello,
  verificaOfferta
}
